// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAZN1tgws1OMVxTuiLp_iqUxrkUROnAryU",
  authDomain: "vto-sprint.firebaseapp.com",
  projectId: "vto-sprint",
  storageBucket: "vto-sprint.appspot.com",
  messagingSenderId: "988373966869",
  appId: "1:988373966869:web:63702bdf68b753cb33ae1c",
  measurementId: "G-ZLJZ8336B5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app); // Initialize Firestore

export { db };